import { QueryClientProvider } from '@tanstack/react-query';
import {
    useFolder,
    UserJourneyServicesProvider,
    UserJourneyServicesConfig,
} from '@axa-fr-axion/user-journey-services';
import { getQueryClient } from 'utils/query-client';
import { InitializationProps } from './Initialization.interface';
import {
    DISABLE_DELAY,
    HEADERS_CORRELATION_NAME,
    BFF_HOST,
    BFF_PATHNAME,
    BFF_FOLDER_PATH,
    BFF_LEAD_PATH,
    BFF_PERSON_PATH,
    BFF_FIND_ADVISORS_ENDPOINT,
    BFF_IDENTIFY_ENDPOINT,
    BFF_REQUEST_CONTACT_ENDPOINT,
} from 'utils';

function Initialization({
    onTechnicalError,
    onSuccess,
    data,
}: InitializationProps): null {
    useFolder(
        data,
        {
            onSuccess,
            onTechnicalError,
        },
    );

    return null;
}

const queryClient = getQueryClient();

const config: UserJourneyServicesConfig = {
    isDelayDisabled: DISABLE_DELAY,
    headersCorrelationName: HEADERS_CORRELATION_NAME,
    bffHost: BFF_HOST,
    bffPathName: BFF_PATHNAME,
    bffFolderPathName: BFF_FOLDER_PATH,
    bffLeadPathName: BFF_LEAD_PATH,
    bffPersonPathname: BFF_PERSON_PATH,
    bffFindAdvisorsEndpoint: BFF_FIND_ADVISORS_ENDPOINT,
    bffIdentifyEndpoint: BFF_IDENTIFY_ENDPOINT,
    bffRequestContactEndpoint: BFF_REQUEST_CONTACT_ENDPOINT,
};

const ConnectedInitialization = (props: InitializationProps): JSX.Element => {
    return (
        <QueryClientProvider client={ queryClient }>
            <UserJourneyServicesProvider config={ config }>
                <Initialization { ...props } />
            </UserJourneyServicesProvider>
        </QueryClientProvider>
    );
};

export default ConnectedInitialization;
export { ConnectedInitialization as Initialization };
